import manager from './manager/index';
import activity from './activity/index';
import instead from './instead/index';

export default {
  modules: {
    manager,
    activity,
    instead,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/index.js